import { BaseOption } from "~/hooks/useDropdown";

export const OPT_JOB_STATUS: BaseOption[] = [
  { label: "Part Time", value: "part-time" },
  { label: "Full Time", value: "full-time" },
];

export const OPT_EYE_COLOR: BaseOption[] = [
  { label: "Amber", value: "Amber" },
  { label: "Blue", value: "Blue" },
  { label: "Brown", value: "Brown" },
  { label: "Gray", value: "Gray" },
  { label: "Green", value: "Green" },
  { label: "Hazel", value: "Hazel" },
];

export const OPT_ETHNICITY: BaseOption[] = [
  { label: "White / Caucasian", value: "White / Caucasian" },
  { label: "Black / of African descent", value: "black" },
  { label: "East or Central Asian", value: "East or Central Asian" },
  { label: "Hispanic, Latino, Spanish origin", value: "Hispanic, Latino, Spanish origin" },
  { label: "Middle Eastern, North African, or Arab", value: "Middle Eastern, North African, or Arab" },
  { label: "Multiracial", value: "Multiracial" },
  { label: "Native Hawaiian or other Pacific Islander", value: "Native Hawaiian or other Pacific Islander" },
  { label: "Southeast Asian (Vietnamese, Cambodian, etc.)", value: "Southeast Asian (Vietnamese, Cambodian, etc.)" },
  {
    label: "South Asian (Indian, Pakistani, Bangladeshi, etc.)",
    value: "South Asian (Indian, Pakistani, Bangladeshi, etc.)",
  },
  { label: "Other", value: "Other" },
];

export const OPT_HAIR_COLOR: BaseOption[] = [
  { label: "Brown", value: "Brown" },
  { label: "Black", value: "Black" },
  { label: "Blonde", value: "Blonde" },
  { label: "Gray", value: "Gray" },
  { label: "Red", value: "Red" },
  { label: "White", value: "White" },
  { label: "Other (color/bald)", value: "Other" },
];

export const OPT_HAIR_LENGTH: BaseOption[] = [
  { label: "Short", value: "Short" },
  { label: "Medium", value: "Medium" },
  { label: "Long", value: "Long" },
  { label: "Bald", value: "Bald" },
];

export interface ClothingTypeOption extends BaseOption<{ femaleImg: string; maleImg: string }> {
  femaleImg: string;
  maleImg: string;
}

export const OPT_CLOTHING_TYPES: ClothingTypeOption[] = [
  {
    label: "Blue Business Suit",
    value: "Blue Business Suit", // same as BE define
    femaleImg: "blue-business-suit-female",
    maleImg: "blue-business-suit-male",
  },
  {
    label: "Grey Business Suit",
    value: "Grey Business Suit",
    femaleImg: "grey-business-suit-female",
    maleImg: "grey-business-suit-male",
  },
  {
    label: "Black Sweater",
    value: "Black Sweater",
    femaleImg: "black-sweater-female",
    maleImg: "black-sweater-male",
  },
  {
    label: "White Office Shirt",
    value: "White Office Shirt",
    femaleImg: "white-office-shirt-female",
    maleImg: "white-office-shirt-male",
  },
  {
    label: "Blue Office Shirt",
    value: "Blue Office Shirt",
    femaleImg: "blue-office-shirt-female",
    maleImg: "blue-office-shirt-male",
  },
  {
    label: "Beige T-Shirt",
    value: "Beige T-Shirt",
    femaleImg: "beige-t-shirt-female",
    maleImg: "beige-t-shirt-male",
  },
  {
    label: "Black T-Shirt",
    value: "Black T-Shirt",
    femaleImg: "black-t-shirt-female",
    maleImg: "black-t-shirt-male",
  },
  {
    label: "Beige Casual Blazer",
    value: "Beige Casual Blazer",
    femaleImg: "beige-casual-blazer-female",
    maleImg: "beige-casual-blazer-male",
  },
  {
    label: "Blue Casual Blazer",
    value: "Blue Casual Blazer",
    femaleImg: "blue-casual-blazer-female",
    maleImg: "blue-casual-blazer-male",
  },
];
